<script>
  import classNames from 'classnames/bind'
  import {
    GridContainer,
    GridColumn,
    Header,
    Text,
    Label,
    Picture,
    Separator,
    ButtonPrimary,
    WidgetHeader,
    WidgetFooter,
  } from '@qlean/ui-kit-web-svelte'

  import css from './_styles'

  const cN = classNames.bind(css)

  export let withTopMargin
  export let withBottomMargin
  export let title
  export let subTitle
  export let titleTag
  export let list
  export let type
  export let elemId
  export let isFirstImageRight = false
  const isSubstrate = type === 'substrate'
</script>

<WidgetHeader {title} {subTitle} {titleTag} withMargin={withTopMargin} />
{#each list as { images, text, button }, idx}
  <GridContainer
    id={idx === 0 ? elemId : undefined}
    class={cN('mosaic', {
      'mosaic--reverse': idx % 2 !== (isFirstImageRight ? 1 : 0),
      'mosaic--substrate': isSubstrate,
    })}>
    <div class={cN('mosaic__wrapper')}>
      {#if !isSubstrate}
        <GridColumn width={0} widthMiddle={1} />
      {/if}
      <GridColumn widthMiddle={4} class={cN('mosaic__picture-wrapper')}>
        <Picture
          class={cN('mosaic__picture')}
          type={Picture.PROPORTIONS.SQUARE}
          fitType={Picture.FIT_TYPES.COVER}
          {...images} />
      </GridColumn>
      <GridColumn widthMiddle={!isSubstrate ? 6 : 7} class={cN('mosaic__text')}>
        {#if text.label !== undefined}
          <Label>{text.label}</Label>
          <Separator key={10} size={Separator.SIZES.MEDIUM} />
          <Header size={Header.SIZES.LIGHT}>{text.title}</Header>
        {:else}
          <Header tag={Header.TAGS.H2} size={Header.SIZES.LIGHT}>{text.title}</Header>
        {/if}
        {#if isSubstrate}
          <Separator key={5} size={Separator.SIZES.MEDIUM} />
        {:else}
          <Separator key={10} size={Separator.SIZES.LARGE} />
        {/if}
        <Text size={Text.SIZES.LARGE}>{text.description}</Text>
        {#if button !== undefined}
          <Separator key={10} size={Separator.SIZES.MEDIUM} />
          <ButtonPrimary
            class={cN('mosaic__button')}
            width={ButtonPrimary.WIDTHS.SMALL}
            height={ButtonPrimary.HEIGHTS.SMALL}
            isLink
            href={button.href}>
            {button.text}
          </ButtonPrimary>
        {/if}
      </GridColumn>
      <GridColumn width={0} widthMiddle={1} />
    </div>
  </GridContainer>
  {#if idx !== list.length - 1}
    <Separator key={30} size={Separator.SIZES.LARGE} />
  {/if}
{/each}
<WidgetFooter withMargin={withBottomMargin} />
